export default {
  meta: {
    title: '一代管理', // 一代管理
    url: '/xtc/branchcompany' // 埋点用，记录所属模块
  },
};
